module.exports = __webpack_public_path__ + "img/24小时预报.69c087ef.png";